<template>
	<div class="container">
		<div class="m_sub_top">
			<div class="top_content">
				<h2 class="headline_m type2">
					{{ $t('rtr_personal-request-deposit.text1') }}
				</h2>
				<p class="body_m">{{ $t('rtr_personal-request-deposit.text2') }}</p>
				<div class="button_area">
					<button class="button_bg_red mr_10" @click="toLogin">
						{{ $t('button.signup') }}
					</button>
					<button class="button_bg_black" @click="notYet">
						{{ $t('button.down') }}
					</button>
				</div>
			</div>
		</div>

		<div class="bottom_area">
			<div class="catch_box">
				<p class="title_l mb_16 fc_white">
					{{ $t('rtr_personal-request-deposit.text3') }}
				</p>
				<p class="body_m fc_white">
					{{ $t('rtr_personal-request-deposit.text4') }}
				</p>
			</div>
			<p class="title_l mt_40 mb_16">
				{{ $t('rtr_personal-request-deposit.text5') }}
			</p>
			<div class="bottom_box">
				<div class="white_box box_01 mb_16">
					<p class="title_m mb_8">
						{{ $t('rtr_personal-request-deposit.text6') }}<br />
						{{ $t('rtr_personal-request-deposit.text7') }}
					</p>
					<p class="body_m">
						{{ $t('rtr_personal-request-deposit.text8') }}<br />
						{{ $t('rtr_personal-request-deposit.text9') }}
					</p>
				</div>
				<div class="white_box box_02">
					<p class="title_m mb_8">
						{{ $t('rtr_personal-request-deposit.text10') }}<br />
						{{ $t('rtr_personal-request-deposit.text11') }}
					</p>
					<p class="body_m">
						{{ $t('rtr_personal-request-deposit.text12') }}<br />
						{{ $t('rtr_personal-request-deposit.text13') }}
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import '@/assets/css/sub.m.css';

export default {
	name: 'Deposit.m',
	setup() {
		return {};
	},
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
		toLogin() {
			this.$router.push({ name: 'auth-login' });
		},
	},
};
</script>
<style scoped></style>
